import { useRouteMeta } from "@/hooks/useRouteMeta";
import { headerColorState, tokenState, alarmState } from "@/state";
import StyledButton from "@/submodules/integration-design-system/systems/moreden/components/styled-button/StyledButton";
import { cls } from "@/utils/util";
import { Link, useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import Logo from "../Logo";
import { useEffect, useState } from "react";
import { headerCustomButtonState } from "@/state";

const isWebview = false;

const AppHeaderMobile = () => {
  const navigate = useNavigate();
  const [isLowScroll, setIsLowScroll] = useState(window.scrollY < 10);
  const routeMeta = useRouteMeta();
  const token = useRecoilValue(tokenState);
  const isLogin = token && token.uid;
  const customButton = useRecoilValue(headerCustomButtonState);
  const headerColor = useRecoilValue(headerColorState);
  const alarm = useRecoilValue(alarmState);
  const unread =
    alarm &&
    alarm.load &&
    alarm.noti &&
    alarm.noti.filter((item: { noti_status: string }) => item.noti_status === "received").length;

  const onPageScroll = () => {
    if (window.scrollY < 10) {
      setIsLowScroll(true);
    } else {
      setIsLowScroll(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", onPageScroll, false);
    return () => {
      window.removeEventListener("scroll", onPageScroll, false);
    };
  }, []);

  if (!routeMeta) return null;

  return (
    <>
      <header
        style={{ color: isLowScroll ? (headerColor as string) : undefined }}
        className={cls("bg-base w-full", isLowScroll ? "bg-transparent" : "bg-white")}
      >
        <div style={{ height: 56 }} className="flex items-center justify-between w-full px-4">
          <div className="flex-0 min-w-[30px] flex gap-3 items-center">
            {routeMeta.back && !isWebview && (
              <button
                className="relative w-[30px] h-[30px]"
                type="button"
                title="뒤로가기"
                onClick={() => window.history.back()}
              >
                <i
                  className={cls(
                    "ii ii-arrow-left text-[24px] text-inherit",
                    "absolute top-[50%] left-[50%] transform translate-x-[-50%] translate-y-[-50%]",
                  )}
                ></i>
              </button>
            )}
            {routeMeta.home && (
              <Link to="/">
                <i className="text-2xl ii ii-home-outline text-inherit"></i>
              </Link>
            )}
            {routeMeta.logo && (
              <h1 className="h-[30px]">
                <Link to="/">
                  <Logo />
                </Link>
              </h1>
            )}
            {routeMeta.title && <h1 className="text-base font-semibold">{routeMeta.title}</h1>}
          </div>
          <div className="flex-0 justify-end max-w-[30px] min-w-[30px] flex gap-4 items-center">
            {isLogin && routeMeta.search && (
              <Link className="order-first" to="/search">
                <i className="text-2xl text-primary ii ii-search ii-weight-700"></i>
              </Link>
            )}
            {isLogin && routeMeta.notification && (
              <Link className="order-first relative" to="/alarm">
                <i className="text-2xl ii ii-bell-outline text-inherit"></i>
                {!alarm.popup && unread && unread > 0 ? (
                  <span className="absolute right-0 top-[1px] flex h-[14px] w-[14px] items-center justify-center rounded-full bg-[#EA4E4E] text-[11px] !text-white">
                    {unread > 9 ? "9+" : unread}
                  </span>
                ) : (
                  <></>
                )}
              </Link>
            )}
            {!isLogin && routeMeta.signin && (
              <Link
                to="/login"
                className="px-2 text-sm cursor-pointer text-secondary w-[50px] whitespace-nowrap text-inherit"
              >
                로그인
              </Link>
            )}
            {!isLogin && routeMeta.register && (
              <StyledButton outlined onClick={() => navigate("/login")}>
                회원가입
              </StyledButton>
            )}
            {customButton && customButton}
          </div>
        </div>
      </header>
    </>
  );
};

export default AppHeaderMobile;
